import React, { useState, useEffect, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import {
  useTable,
  useSortBy,
  usePagination,
  useRowSelect,
  useExpanded,
} from "react-table";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Config from "../../Config.js";
import swal from "sweetalert";

import { CheckQRCodeCategoriesManagementEnabled } from "../../api/packageApi";

function Categories(props) {
  let history = useHistory();
  //const [Category_ID, setCategory_ID] = useState('');
  //const [SubCategoryError, setSubCategoryError] = useState('');
  //const [SubCategoryList, setSubCategoryList] = useState([]);
  //const [SubCategory, setSubCategory] = useState('');
  // const [CategoryName, setCategoryName] = useState('');
  // const [CategoryNameError, setCategoryNameError] = useState('');
  const [CategoryList, setCategoryList] = useState([]);
  const [CategoryListDropDowan, setCategoryListDropDowan] = useState([]);

  const [subcategorylistnew, setsubcategorylistnew] = useState([]);
  // const [show, setshow] = useState(false);

  const [MainCategoryId, setMainCategoryId] = useState("");
  const [MainCategory, setMainCategory] = useState("");
  const [MainCategoryError, setMainCategoryError] = useState("");
  const [CategoryId, setCategoryId] = useState("");
  const [modalcategoryAdd, setmodalcategoryAdd] = useState(false);
  const [modalcategoryEdit, setmodalcategoryEdit] = useState(false);

  const [SubCategoryEmptyError, setSubCategoryEmptyError] = useState("");
  const [isSubcategoryMaltiple, setisSubcategoryMaltiple] = useState(false);
  const [CategoryItem, setCategoryItem] = useState([]);
  //pagination
  const [PerPageCount, setPerPageCount] = useState(10);
  const [TotalCount, setTotalCount] = useState(0);
  const [SortColumnType, setSortColumnType] = useState("Desc");
  const [SortColumn, setSortColumn] = useState("addeddate");
  //const [SearchValue, setSearchValue] = useState('');
  const [CurrentPageNo, setCurrentPageNo] = useState(1);
  const [ShowPaggingCount, setShowPaggingCount] = useState(4);
  const [PaginationGroupList, setPaginationGrouplist] = useState([]);
  const [canPreviousPage, setcanPreviousPage] = useState(false);
  const [canNextPage, setcanNextPage] = useState(true);
  const [PaggingList, setPaggingList] = useState([]);
  const [userLoaded, setUserLoaded] = useState(false);
  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === "" ||
      checkLogin === undefined ||
      checkLogin === null
    ) {
      history.push("/Login");
    } else {
      getAllCategoryDropdownlists();
      //getData();
    }
  }, []);

  useEffect(() => {
    setPaggingDDL();
    getPaginationGroup();
  }, [TotalCount]);

  useEffect(() => {
    getData();
  }, [PerPageCount, SortColumnType, CurrentPageNo, userLoaded]);

  const getAllCategoryDropdownlists = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(Config.apiUrl + "Category/CategoryDrodownList", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setCategoryListDropDowan(result);
        } else {
          setCategoryListDropDowan([]);
        }
      });
    });
  };
  const setPaggingDDL = () => {
    var testDDL = [];

    if (TotalCount <= 10) {
      testDDL = [10, TotalCount];
    } else if (TotalCount <= 20) {
      testDDL = [10, 20, TotalCount];
    } else if (TotalCount <= 30) {
      testDDL = [10, 20, 30, TotalCount];
    } else if (TotalCount <= 50) {
      testDDL = [10, 20, 30, 50, TotalCount];
    } else if (TotalCount <= 100) {
      testDDL = [10, 20, 30, 50, 100, TotalCount];
    } else if (TotalCount <= 200) {
      testDDL = [10, 20, 30, 50, 100, 200, TotalCount];
    } else if (TotalCount <= 300) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, TotalCount];
    } else if (TotalCount <= 400) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, 400, TotalCount];
    } else if (TotalCount <= 500) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, 400, 500, TotalCount];
    }
    setPaggingList(testDDL);
  };

  const getPaginationGroup = () => {
    if (TotalCount > 0) {
      let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
      //let start = Math.floor((CurrentPageNo - 1) / PerPageCount) * PerPageCount;
      let LastPageNo = Math.ceil(TotalCount / PerPageCount);
      if (PerPageCountobj === 1) {
        setcanPreviousPage(false);
        setcanNextPage(false);
      }
      let testArray = [];
      for (var tt = 1; tt <= TotalCount; tt++) {
        if (
          tt >= CurrentPageNo - ShowPaggingCount &&
          tt <= CurrentPageNo + ShowPaggingCount
        ) {
          if (tt <= LastPageNo) {
            testArray.push(tt);
          }
        }
      }
      setPaginationGrouplist(testArray);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Sr.#",
        accessor: "srno",
        selector: "srno",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          return (
            <span className="mb-0" style={{ width: "20px" }}>
              {row?.row?.original?.sr}
            </span>
          );
        },
      },
      {
        Header: "Main category",
        accessor: "maincategory",
        selector: "maincategory",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          return (
            <div className="onlydata-scroll" style={{ width: "200px" }}>
              <p className="mb-0">{row?.row?.original?.name}</p>
            </div>
          );
        },
      },
      {
        id: "expander",
        Header: "Sub categories",
        accessor: "subCategoryList",
        selector: "subCategoryList",
        sortable: false,
        Cell: ({ row }) =>
          row.canExpand === false ? (
            <>
              <div
                className="Subcategorytable"
                {...row.getToggleRowExpandedProps({})}
              >
                <p className="mb-0">SubCategory</p>
                {row.isExpanded ? (
                  <div>
                    <i className="fas fa-lg fa-fw m-r-10 fa-minus-circle"></i>
                  </div>
                ) : (
                  <div>
                    <i className="fas fa-lg fa-fw m-r-10 fa-plus-circle"></i>
                  </div>
                )}
              </div>
              {row.isExpanded ? (
                <ul>
                  {row?.original?.subCategoryModelList?.map((genre, idx) => {
                    return (
                      <li
                        key={genre?._id}
                        className="mb-3 text-left"
                        style={{ width: "200px" }}
                      >
                        {genre?.name}
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <></>
              )}
            </>
          ) : null,
      },

      {
        Header: " Created date",
        accessor: "addeddate",
        selector: "addeddate",
        sortable: true,
        Cell: (row) => {
          let date = new Date(row?.row?.original?.createdDate);
          let dateMDY = `${date.getDate()}-${
            date.getMonth() + 1
          }-${date.getFullYear()}`;
          return <span className="mb-0">{dateMDY}</span>;
        },
      },

      {
        Header: "Owner",
        accessor: "Owner",
        selector: "Owner",
        sortable: false,
        Cell: (row) => {
          let FullOwnerpath = `${
            Config.contentUrl + row.row.original.ownerImage
          }`;
          return (
            //<img src={FullPathQrcode} alt="img" style={{ height: '40px' }}></img>
            <div className="data-scroll">
              <img
                src={FullOwnerpath}
                className="rounded-circle"
                style={{ height: "40px", width: "40px", objectFit: "cover" }}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = "../assets/img/new-images/images.png";
                }}
              ></img>
              {/* <img src="../assets/img/user/user-1.jpg" alt="img" style={{ height: '40px', }} className='rounded-circle'></img> */}
              <p>{row.row.original.ownerName}</p>
            </div>
          );
        },
      },

      {
        Header: " Actions",
        accessor: "col13",
        sortable: false,
        Cell: (row) => {
          return (
            <div style={{ width: "100px" }}>
              <button
                type="button"
                className="btn btn-primary btn-sm mr-2"
                onClick={(e) => {
                  EditCategoryDetails(row?.row?.original);
                }}
              >
                <i className="ion ion-md-create "></i>
              </button>
              <button
                type="button"
                className="btn btn-danger btn-sm"
                onClick={(e) => {
                  DeleteCategoryDetails(row?.row?.original?._id);
                }}
              >
                <i className="fas fa-trash"></i>
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const EditCategoryDetails = (row) => {
    setMainCategoryId(row?._id);
    setMainCategory(row?.name);
    if (row?._id != null && row?._id != undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(Config.apiUrl + "Category/SubCategory?categoryID=" + row?._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }).then((resp1) => {
        resp1.json().then((result) => {
          if (result != null) {
            setCategoryItem(result);
          }
          setmodalcategoryEdit(true);
        });
      });
    }
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    //rows,
    page,
    // pageOptions,
    toggleAllRowsSelected,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data: CategoryList,
      manualPagination: true,
      sortable: false,
      manualSortBy: true,
    },
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          _id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );
  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);

      return (
        <>
          <input type="checkbox" ref={resolvedRef} {...rest} />
        </>
      );
    }
  );

  const handlePageCountChange = (event) => {
    setCurrentPageNo(1);
    setPerPageCount(event);

    if (event >= TotalCount) {
      setcanPreviousPage(false);
      setcanNextPage(false);
    } else {
      setcanPreviousPage(false);
      setcanNextPage(true);
    }
  };

  const onChangeCategory = (event) => {
    let catId = event.target.value;
    setCategoryId(catId);
  };
  const nextPage = () => {
    setCurrentPageNo((CurrentPageNo) => CurrentPageNo + 1);
    setcanPreviousPage(true);
    let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
    let temp = Math.ceil(CurrentPageNo + 1);
    if (temp === PerPageCountobj) {
      setcanNextPage(false);
    }
  };

  const toggleAddnewCategories = () => {
    setmodalcategoryAdd(!modalcategoryAdd);
    setMainCategory("");
    setsubcategorylistnew([""]);
  };

  const togglecategoryEdit = () => {
    setmodalcategoryEdit(!modalcategoryEdit);
    setMainCategory("");
    setMainCategoryError("");
    setMainCategoryId("");
    setCategoryItem([]);
    //setsubcategorylistnew(['']);
  };

  const onChangeMaincategory = (event) => {
    setMainCategoryError("");
    setMainCategory(event.target.value);
  };

  const createSubCategoryUI = () => {
    return subcategorylistnew.map((el, i) => (
      <>
        <div key={i} className="removeSection">
          <input
            maxLength={30}
            type="text"
            className="form-control mr-2"
            maxlength="30"
            placeholder="Enter Sub Category (Maximum 30 Character)"
            value={el || ""}
            onChange={SubCategoryhandleChange(i)}
          />
          {CategoryItem.length > 0 ? (
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                SubCategoryremoveClick(i);
              }}
              className="btn btn-danger"
            >
              <i class="fas fa-trash"></i>
            </a>
          ) : i > 0 ? (
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                SubCategoryremoveClick(i);
              }}
              className="btn btn-danger"
            >
              <i class="fas fa-trash"></i>
            </a>
          ) : (
            ""
          )}
        </div>
        <p
          class="col-sm-12"
          style={{ textAlign: "right", fontSize: 12, color: "red" }}
        >
          {el.length}/30
        </p>
      </>
    ));
  };

  const SubCategoryhandleChange = (i) => (event) => {
    setSubCategoryEmptyError("");
    setisSubcategoryMaltiple(false);
    let subcategorylistnewTemp = [...subcategorylistnew];
    let subcategorylistoldTemp = [...CategoryItem];
    subcategorylistnewTemp[i] = event.target.value;
    setsubcategorylistnew(subcategorylistnewTemp);
    const unique = [...new Set(subcategorylistnewTemp)];
    if (subcategorylistnewTemp.length !== unique.length) {
      setisSubcategoryMaltiple(true);
    }
    if (subcategorylistoldTemp.length > 0) {
      const found = subcategorylistoldTemp.find(
        (element) => element.name === event.target.value
      );
      if (found != undefined) {
        setisSubcategoryMaltiple(true);
      }
    }
  };

  const SubCategoryhandleChangeOld = (i) => (event) => {
    setSubCategoryEmptyError("");
    setisSubcategoryMaltiple(false);
    let subcategorylistoldTemp = [...CategoryItem];
    let subcategorylistNewTemp = [...subcategorylistnew];
    const found = subcategorylistoldTemp.find(
      (element) => element.name == event.target.value
    );
    if (found != undefined) {
      setisSubcategoryMaltiple(true);
    } else {
      if (subcategorylistNewTemp.length > 0) {
        const foundnew = subcategorylistNewTemp.find(
          (element) => element == event.target.value
        );
        if (foundnew != undefined) {
          setisSubcategoryMaltiple(true);
        }
      }
    }
    subcategorylistoldTemp[i].name = event.target.value;
    setCategoryItem(subcategorylistoldTemp);
  };

  const SubCategoryaddClick = () => {
    setsubcategorylistnew((n) => [...n, ""]);
  };

  const RemovedSubCategory = (i) => {
    let CategoryItemObj = [...CategoryItem];
    if (CategoryItemObj != null) {
      CategoryItemObj.splice(i, 1);
    }
    setCategoryItem(CategoryItemObj);
  };
  const SubCategoryremoveClick = (i) => {
    setSubCategoryEmptyError("");
    let subcategorylistnewObj = [...subcategorylistnew];
    subcategorylistnewObj.splice(i, 1);
    setsubcategorylistnew(subcategorylistnewObj);
    const unique = [...new Set(subcategorylistnewObj)];
    if (subcategorylistnewObj.length === unique.length) {
      setisSubcategoryMaltiple(false);
    } else {
      setisSubcategoryMaltiple(true);
    }
  };

  const SubCategoryhandleSubmit = (event) => {
    event.preventDefault();
  };

  const getData = () => {
    setTotalCount(0);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
        "Category/SearchPagination?sortingColumnName=" +
        SortColumn +
        "&ascDesc=" +
        SortColumnType +
        "&pageNo=" +
        CurrentPageNo +
        "&pageSize=" +
        PerPageCount +
        "&categoryName=" +
        CategoryId +
        "&owner=" +
        "",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setCategoryList(result.categoryList);
          setTotalCount(result.totalcount);
        } else {
          setTotalCount(0);
          setCategoryList([]);
        }
      });
    });
  };

  const createCategory = () => {
    let retval = true;
    const unique = [...new Set(subcategorylistnew)];
    if (subcategorylistnew.length !== unique.length) {
      retval = false;
      setisSubcategoryMaltiple(true);
    }
    if (
      MainCategory === null ||
      MainCategory === "" ||
      MainCategory === undefined
    ) {
      retval = false;
      setMainCategoryError("Category Name must be filled out");
    }
    const found = subcategorylistnew.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setSubCategoryEmptyError("Sub Category Name must be filled out");
      retval = false;
    }

    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (retval === true) {
      fetch(
        Config.apiUrl +
          "Category/CheckCategory?id=" +
          "" +
          "&categoryName=" +
          MainCategory,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            var data = {
              Name: MainCategory,
              SubCategoryList: subcategorylistnew,
              UserCompanyID: loginid,
              ParentID: "0",
            };
            fetch(Config.apiUrl + "Category/CreateCategory", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(data),
            })
              .then((result1) => {
                result1.json().then((resp) => {
                  if (resp != null) {
                    getAllCategoryDropdownlists();
                    getData();
                    // setshow(false);
                    Categoryclearform();
                    toggleAddnewCategories();
                    swal("Congratulations! Your data successfully save.", {
                      icon: "success",
                    });
                  }
                });
              })
              .catch((error) => {
                console.error("There was an error!", error);
              });
          } else {
            swal("Your Category name already exists !");
          }
        });
      });
    }
  };
  const Categoryclearform = () => {
    setMainCategory("");
    setsubcategorylistnew([]);
  };

  const onSelcetdCategoryDelete = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let TotalIteam = [];
    for (let index = 0; index < selectedFlatRows.length; index++) {
      TotalIteam.push(selectedFlatRows[index].original._id);
    }
    if (TotalIteam.length > 0) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this category !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "Category/MultipleDelete?id[]=" + TotalIteam, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
            body: JSON.stringify(TotalIteam),
          }).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                getAllCategoryDropdownlists();
                getData();
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your  Category  is safe!");
              }
            });
          });
        }
      });
    } else {
      swal("Sorry!", "pleace select category !", "error");
    }
  };
  const DeleteCategoryDetails = (C_ID) => {
    if (C_ID != "" && C_ID != "" && C_ID != undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this category !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "Category/Delete?id=" + C_ID, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                getAllCategoryDropdownlists();
                getData();
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Category is safe!");
              }
            });
          });
        }
      });
    } else {
      swal("Sorry!", "pleace Select Category.", "error");
    }
  };

  const UpdateCategory = () => {
    let retval = true;
    setisSubcategoryMaltiple(false);

    if (
      MainCategory === null ||
      MainCategory === "" ||
      MainCategory === undefined
    ) {
      retval = false;
      setMainCategoryError("Category Name must be filled out");
    }
    if (subcategorylistnew.length > 0) {
      const found = subcategorylistnew.find(
        (element) => element === "" || element === "" || element === null
      );
      if (found != undefined) {
        setSubCategoryEmptyError("Sub Category Name must be filled out");
        retval = false;
      }
    }
    if (CategoryItem.length > 0) {
      const foundOld = CategoryItem.find(
        (element) =>
          element.name === "" || element.name === "" || element.name === null
      );
      if (foundOld != undefined) {
        setSubCategoryEmptyError("Sub Category Name must be filled out");
        retval = false;
      }

      CategoryItem.map((tag, i) => {
        const issmaeData = CategoryItem.filter(
          (x) => x._id != tag._id && x.name === tag.name
        );
        if (issmaeData.length > 0) {
          retval = false;
          setisSubcategoryMaltiple(true);
        }
      });
    }
    const unique = [...new Set(subcategorylistnew)];
    if (subcategorylistnew.length !== unique.length) {
      retval = false;
      setisSubcategoryMaltiple(true);
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (retval === true) {
      let subcategoryitemupdate = [];
      if (subcategorylistnew.length > 0) {
        subcategorylistnew.map((item, i) => {
          let SubcategoryDetlis = {
            _id: "",
            name: item,
          };
          subcategoryitemupdate.push(SubcategoryDetlis);
        });
      }
      if (CategoryItem.length > 0) {
        CategoryItem.map((item, i) => {
          let SubcategoryDetlis = {
            _id: item._id,
            name: item.name,
          };
          subcategoryitemupdate.push(SubcategoryDetlis);
        });
      }
      fetch(
        Config.apiUrl +
          "Category/CheckCategory?id=" +
          MainCategoryId +
          "&categoryName=" +
          MainCategory,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            var data = {
              _id: MainCategoryId,
              Name: MainCategory,
              subCategoryModelList: subcategoryitemupdate,
              UserCompanyID: loginid,
              ParentID: "0",
            };
            fetch(
              Config.apiUrl + "Category/UpdateCategory?id=" + MainCategoryId,
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                body: JSON.stringify(data),
              }
            )
              .then((result1) => {
                result1.json().then((resp) => {
                  if (resp != null) {
                    setsubcategorylistnew([])
                    getAllCategoryDropdownlists();
                    setMainCategory("");
                    getData();
                    togglecategoryEdit();
                    swal("Congratulations! Your data successfully update.", {
                      icon: "success",
                    });
                  } else {
                    swal(
                      "Sorry!",
                      " Your data not successfully Update",
                      "error"
                    );
                  }
                });
              })
              .catch((error) => {
                console.error("There was an error!", error);
              });
          } else {
            swal("Your Category name already exists !");
          }
        });
      });
    }
  };

  const deleteCategory = (id) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        fetch(Config.apiUrl + "Category/DeleteCategory?ID=" + id, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }).then((result) => {
          result.json().then((resp) => {
            getAllCategoryDropdownlists();
            getData();
            if (resp === true) {
              swal("Congratulations! Your data deleted successfully.", {
                icon: "success",
              });
            } else {
              swal("Your Category is safe!");
            }
          });
        });
      }
    });
  };

  const ArticleDetailsSearch = (itemSearchValue) => {
    const itemlength = itemSearchValue.length;
    if (itemlength > 2) {
      getData();
    }
  };
  const handleColumnSort = (event) => {
    setCurrentPageNo(1);
    setcanPreviousPage(false);
    setcanNextPage(true);
    setSortColumn(event.selector);
    let SortType = "Desc";
    if (SortColumnType == "Desc") {
      SortType = "Asc";
    }
    setSortColumnType(SortType);
  };
  const gotoPage = () => {
    if (CurrentPageNo > 1) {
      setCurrentPageNo((CurrentPageNo) => CurrentPageNo - 1);
      let temp = Math.ceil(CurrentPageNo - 1);
      if (temp === 1) {
        setcanPreviousPage(false);
      } else {
        setcanPreviousPage(true);
        setcanNextPage(true);
      }
    }
  };

  const changePage = (event) => {
    const pageNumber = Number(event.target.textContent);
    if (pageNumber === 1) {
      setcanPreviousPage(false);
      setcanNextPage(true);
    } else {
      setcanPreviousPage(true);
    }
    setCurrentPageNo(pageNumber);
    let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);

    if (pageNumber === PerPageCountobj) {
      setcanNextPage(false);
    } else {
      setcanNextPage(true);
    }
  };
  const SearchFilter = () => {
    setCurrentPageNo(1);
    getData();
  };

  const ExportDeatlis = () => {
    let TotalIteam = [];
    for (let index = 0; index < selectedFlatRows.length; index++) {
      TotalIteam.push(selectedFlatRows[index].original._id);
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (TotalIteam.length > 0) {
      fetch(Config.apiUrl + "Category/Export", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(TotalIteam),
      })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = "ExportCategory.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();
          deselectAllRows();
        });
    } else {
      swal("Sorry!", "pleace select category !", "error");
    }
  };
  const deselectAllRows = useCallback(() => {
    Object.keys(selectedRowIds).forEach((key, index) => {
      selectedRowIds[key] = false;
    });
    toggleAllRowsSelected(false);
  }, [selectedRowIds, toggleAllRowsSelected]);

  const CategoryListReset = () => {
    setCategoryId("");
    setUserLoaded(!userLoaded);
    //getData()
  };

  return (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/dashboard/v3">Home</Link>
        </li>
        <li className="breadcrumb-item active">Categories</li>
      </ol>
      <h1 className="page-header">Categories</h1>
      <div className="row d-flex justify-content-end mb-2">
        <div className="col-md-12 row justify-content-end">
          <button
            //onClick={(e) => { toggleAddnewCategories(e)}}

            onClick={async (e) => {
              try {
                let response = await CheckQRCodeCategoriesManagementEnabled();
                if (response === true || response === "true") {
                  toggleAddnewCategories(e);
                } else {
                  swal(
                    "oops!",
                    "Sorry! to increase your qrcode categories management enabled.",
                    "warning"
                  );
                }
              } catch (error) {
                console.log("error!", error);
              }
            }}
            type="button"
            className="btns btn btn-primary search-btn mr-2 mb-1"
          >
            <i className="fas fa-lg fa-fw m-r-5 fa-plus-square icon"></i>
            Add new
          </button>

          <button
            type="button"
            className=" btns btn btn-green mr-2 mb-1"
            onClick={(e) => {
              ExportDeatlis();
            }}
          >
            <i class="fas  fa-sm fa-fw m-r-5 fa-download icon"></i>
            Export
          </button>
          <button
            type="button"
            className="btns btn  btn-danger mr-2 mb-1"
            onClick={(e) => {
              onSelcetdCategoryDelete(e);
            }}
          >
            <i className="far fa-lg fa-fw m-r-5 fa-trash-alt icon"></i>
            Delete (selected)
          </button>
        </div>
      </div>
      <Panel>
        <PanelHeader>
          <div>
            <h4 className="mb-0 text-light">
              <i className="fas fa-fw m-r-10 fa-search"></i> Search
            </h4>
          </div>
        </PanelHeader>
        <PanelBody>
          <div className="row mt-5">
            <div className="col-xl-6 px-4">
              <fieldset>
                <div className="form-group row m-b-15 d-flex align-items-center">
                  <label className="col-md-4 col-form-label product-lable">
                    Name
                  </label>
                  <div className="d-none d-md-block d-lg-block">:</div>
                  <div className="col-md-7">
                    <select
                      className="default-select2 form-control"
                      value={CategoryId}
                      onChange={onChangeCategory}
                    >
                      <option value="" selected>
                        ---Enter category name---
                      </option>
                      {CategoryListDropDowan.map((item) => (
                        <option value={item?.text}>{item?.text}</option>
                      ))}
                    </select>

                    {/* {CategoryError.length > 0 &&
                                                <span style={{ color: 'red', marginLeft: 6 }}>{CategoryError}</span>} */}
                  </div>
                </div>
              </fieldset>
            </div>
            {/* <div className="col-xl-6 px-4">
              <form action="" method="POST">
                <fieldset>
                  <div className="form-group row m-b-15 d-flex align-items-center">
                    <label className="col-md-4 col-form-label product-lable">
                      Owner{" "}
                    </label>
                    <div className="d-none d-md-block d-lg-block">:</div>
                    <div className="col-md-7">
                      <select className="default-select2 form-control">
                        <option value="" disabled selected>
                          --Select Owner--
                        </option>
                        <option value="CA">Yes</option>
                        <option value="NV">No</option>
                      </select>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div> */}
          </div>
          <div className="row  justify-content-center">
            <button
              type="button"
              className="btn btn-primary search-btn d-flex align-items-center mr-2"
              onClick={SearchFilter}
            >
              <i className="fas fa-lg fa-fw m-r-10 fa-search "></i>
              Search
            </button>
            <button
              type="button"
              className="btn btn-danger d-flex align-items-center"
              onClick={() => {
                CategoryListReset();
              }}
            >
              Reset
            </button>
          </div>
        </PanelBody>
      </Panel>

      <Modal
        isOpen={modalcategoryAdd}
        toggle={toggleAddnewCategories}
        onHide={() => toggleAddnewCategories()}
      >
        <ModalHeader toggle={toggleAddnewCategories} className="modalheader ">
          <h4 className="text-white mb-0">Add Category</h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">
              <h5 className="mb-0">Main Category</h5>
            </label>
            <input
              type="text"
              maxlength="30"
              className="form-control"
              placeholder="Please Enter Main Category (Maximum 30 Character)"
              value={MainCategory}
              onChange={onChangeMaincategory}
            />
            <p
              style={{
                fontSize: 12,
                color: "red",
                marginTop: "7px",
                marginLeft: "10px",
              }}
            >
              {MainCategory?.length}/30
            </p>
            {MainCategoryError.length > 0 && (
              <span style={{ color: "red", marginLeft: 6 }}>
                {MainCategoryError}
              </span>
            )}
          </div>
          <div className="form-group">
            <form onSubmit={SubCategoryhandleSubmit} className="row mb-2">
              <div className="col-md-12">
                <label
                  htmlFor="exampleInputPassword1"
                  className="mt-2 d-flex align-items-center"
                >
                  <h5 className="mb-0">Sub Category</h5>
                  <button
                    type="button"
                    className="m-l-10 btn btn-link"
                    onClick={SubCategoryaddClick}
                  >
                    <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
                  </button>
                </label>
              </div>

              {/* <div className="col-md-3">
                                <button type='button' value='Add' className="form-control btn btn-info width150" onClick={SubCategoryaddClick}>hello</button>
                            </div> */}
            </form>
            <div className="input-group m-b-10">
              <div className="" style={{ width: "100%" }}>
                {createSubCategoryUI()}
              </div>
              {isSubcategoryMaltiple === true ? (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {"Sub Category name dublicate"}
                </span>
              ) : (
                ""
              )}

              {SubCategoryEmptyError.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {SubCategoryEmptyError}
                </span>
              )}
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={() => {
                createCategory();
              }}
              className="btn btn-sm btn-primary m-r-5 shadow-add "
            >
              Create
            </button>
            <button
              type="button"
              onClick={() => {
                toggleAddnewCategories();
              }}
              className="btn btn-sm btn-danger shadow-add "
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalcategoryEdit} toggle={togglecategoryEdit}>
        <ModalHeader toggle={togglecategoryEdit} className="modalheader">
          <h4 className="mb-0 text-white">Edit Category</h4>{" "}
        </ModalHeader>
        <ModalBody>
          <form action="" method="POST" className="m-b-30">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Main Category</label>
              <input
                type="text"
                maxlength="30"
                className="form-control col-sm-12"
                placeholder="Please Enter Main Category (Maximum 30 Character)"
                value={MainCategory}
                onChange={onChangeMaincategory}
              />
              <p
                style={{
                  fontSize: 12,
                  color: "red",
                  marginTop: "7px",
                  marginLeft: "10px",
                }}
              >
                {MainCategory?.length}/30
              </p>
              {MainCategoryError.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {MainCategoryError}
                </span>
              )}
              {/* <button type="button" className="btn btn-sm btn-danger shadow-add m-l-10 col-sm-1"><i className="fas fa-lg fa-fw  fa-trash-alt"></i></button> */}
            </div>

            <div className="form-group">
              <form onSubmit={SubCategoryhandleSubmit} className="row mb-2">
                <div className="col-md-12">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="mt-2 d-flex align-items-center"
                  >
                    <h5 className="mb-0">Sub Category</h5>
                    <button
                      type="button"
                      className="m-l-10 btn btn-link"
                      onClick={SubCategoryaddClick}
                    >
                      <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
                    </button>
                  </label>
                </div>
                {/*
                                <div className="col-md-3">
                                    <input type='button' value='Add more' className="form-control btn btn-info width150" onClick={SubCategoryaddClick} />
                                </div> */}
              </form>
              <div className="input-group m-b-10">
                {CategoryItem != null ? (
                  CategoryItem.map((item, index) => (
                    <div className="" style={{ width: "100%" }}>
                      <div key={index} className="removeSection">
                        <input
                          type="text"
                          className="form-control mr-2"
                          placeholder="Enter Sub Category"
                          value={item.name}
                          onChange={SubCategoryhandleChangeOld(index)}
                        />
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            RemovedSubCategory(index);
                          }}
                          className="btn btn-danger"
                        >
                          <i class="fas fa-trash"></i>
                        </a>
                      </div>
                    </div>
                  ))
                ) : (
                  <></>
                )}
                <div className="" style={{ width: "100%" }}>
                  {createSubCategoryUI()}
                </div>
                {isSubcategoryMaltiple === true ? (
                  <span style={{ color: "red", marginLeft: 6 }}>
                    {"Sub Category name dublicate"}
                  </span>
                ) : (
                  ""
                )}

                {SubCategoryEmptyError.length > 0 && (
                  <span style={{ color: "red", marginLeft: 6 }}>
                    {SubCategoryEmptyError}
                  </span>
                )}
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={() => {
                  UpdateCategory();
                }}
                className="btn btn-sm btn-primary m-r-5 shadow-add "
              >
                Update
              </button>
              <button
                type="button"
                onClick={() => {
                  togglecategoryEdit();
                }}
                className="btn btn-sm btn-danger shadow-add "
              >
                Cancel
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>
      {/* <CategoryList1 /> */}

      <Panel>
        <PanelHeader>
          <h4 className="mb-0 text-light">All Categories</h4>
        </PanelHeader>

        <hr class="m-0" />
        <PanelBody>
          <div className="row">
            <div className="col-xl-6 d-flex align-items-center">
              <div className="form-group  d-flex mb-0 m-r-10 align-items-center allPublishedinput">
                <label className="col-form-label p-0 mr-2">All</label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail2"
                  onKeyUp={(e) => {
                    ArticleDetailsSearch(e.target.value);
                  }}
                  placeholder={"" + TotalCount + ""}
                />
              </div>

              <div className="display">
                <select
                  className="form-control"
                  value={PerPageCount}
                  onChange={(e) => {
                    handlePageCountChange(Number(e.target.value));
                  }}
                >
                  {PaggingList.map((pageSize) => {
                    return pageSize == TotalCount ? (
                      <option key={pageSize} value={pageSize}>
                        Show All
                      </option>
                    ) : (
                      <option key={pageSize} value={pageSize}>
                        Show {pageSize}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
          <div class="table-responsive mt-3">
            <table
              class="table table-bordered table-striped text-center"
              {...getTableProps()}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    style={{ textAlign: "center" }}
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        className="align-middle"
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        <div
                          class="d-flex table-header"
                          style={{ minWidth: "" }}
                        >
                          <span>{column.render("Header")}</span>
                          <span
                            onClick={(e) => {
                              handleColumnSort(column);
                            }}
                          >
                            {column.sortable ? (
                              SortColumn === column.selector ? (
                                SortColumnType == "Desc" ? (
                                  <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                                ) : (
                                  <i className="fa fa-sort-up fa-fw f-s-14 text-blue"></i>
                                )
                              ) : (
                                <i className="fa fa-sort fa-fw f-s-14 opacity-3"></i>
                              )
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()} className="align-middle">
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <div>
              Showing{" "}
              <strong>
                {CurrentPageNo} of {Math.ceil(TotalCount / PerPageCount)}
              </strong>{" "}
              entries
            </div>

            <ul class="pagination justify-content-end flex-wrap align-items-center mt-3">
              <li class="page-item">
                {canPreviousPage == true ? (
                  <a
                    class="page-link mr-2"
                    href="javascript:void(0);"
                    onClick={() => gotoPage(0)}
                  >
                    Previous
                  </a>
                ) : (
                  <a
                    class="page-link mr-2"
                    href="javascript:void(0);"
                    disabled={true}
                  >
                    Previous
                  </a>
                )}
              </li>

              {PaginationGroupList.map((item, index) => (
                <li>
                  <button
                    key={index}
                    onClick={changePage}
                    className={`btn ml-2 ${
                      CurrentPageNo === item ? "page-link-1" : "btn-white"
                    }`}
                  >
                    <span>{item}</span>
                  </button>
                </li>
              ))}

              <li class="page-item ml-2">
                {canNextPage == true ? (
                  <a
                    class="page-link"
                    href="javascript:void(0);"
                    onClick={() => nextPage()}
                  >
                    Next
                  </a>
                ) : (
                  <a
                    class="page-link"
                    href="javascript:void(0);"
                    disabled={true}
                  >
                    Next
                  </a>
                )}
              </li>
            </ul>
          </div>
        </PanelBody>
      </Panel>
    </div>
  );
}

export default Categories;
